import type { FaireProductEntity } from "../../entity_types/product";

export const p_76xfwbsrfp: FaireProductEntity = {
  token: "p_76xfwbsrfp",
  type: "product",
  name: "Black Hog Game Day Mascot Sequins Patch -Small",
  brandToken: "b_a9hebqmabw",
  brandName: "ABLNco",
  imageUrl:
    "https://cdn.faire.com/fastly/21c52f772020eca03502c192f8472c974c0432022dd45ef6c85280904661da8e.jpeg",
  galleryImageUrls: [],
  priceDollars: 6.58,
  description:
    '- Check out our other patch listing options we are a growing brand and are adding to our collections weekly!\n\n✨Size: 3.7" H *  3.6" W \n\nPlease be aware this for your own DIY hat bar. Proper tools are needed for the best long lasting wear \n\nWe have over 2000+ small patches and more to come.. Come check back often for our newly added items ',
  tags: [],
  msrpDollars: 11.89,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:49.361Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
